<template>
  <div class="root-container" v-if="forceUpdateFlag">
    <grid-layout ref="gridlayout" class="gridlayout" :layout.sync="viewLayout" :col-num="cols" :responsive="responsive"
      :row-height="30" :is-draggable="false" :is-resizable="true" :vertical-compact="true" :use-css-transforms="false">
      <grid-item drag-allow-from=".bi-layout-drag-handle"
        :style="{ background: item.styleConfig && item.styleConfig.commongConfig.customBackgroundColor ? item.styleConfig.commongConfig.backgroundColor : '#fff' }"
        :key="item._id" v-for="item in viewLayout" :static="getPreviewFlag" @resized="resizedEvent(item)" :x="item.x"
        :y="item.y" :w="item.w" :h="item.h" drag-ignore-from=".jzliu-bi-engine-middle-layer" :i="item.i">
        <div class="jzliu-bi-engine-chart-warp grid-warp">
          <middle-layer :dashboardName="dashboardName" :chartDirection="chartDirection" :chartPreviewMode="chartPreviewMode" :previewMode="previewMode" @sort-change="handleSortChange" @drill-item-click="(data)=>handleDrillItemClick(data, item)" @handle-table-command="(command)=>handleTableCommand(command, item)" @table-page-change="handleTablePageChange" @click.native="chartSelect(item)" :chartData="item"></middle-layer>
        </div>
      </grid-item>
    </grid-layout>
    <div class="gap"></div>
  </div>
</template>

<script>
import { GridLayout, GridItem } from 'vue-grid-layout'
import middleLayer from '../charts/middleLayer'
// 移除 Vuex 依赖，使用 props 传递状态
import { elResizeObverse } from '../../utils'
const _ = require('lodash')

export default {
  name: 'canvasPanel',
  components: { GridLayout, GridItem, middleLayer },
  props: {
    dashboardName: {
      type: String,
      default: '',
    },
    chartDirection: {
      type: String,
      default: 'rtl'
    },
    chartPreviewMode: {
      type: String,
      default: 'dialog'
    },
    previewMode: {
      type: String,
      default: 'drawer'
    },
    gridLayout: {
      type: Array,
      default: () => [],
    },
    previewFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cols: 12,
      draggable: true,
      resizable: true,
      responsive: false,
      forceUpdateFlag: true,
      index: 0,
      cur: {},
      observer: null,
    }
  },
  computed: {
    // 使用 props 传递的状态
    getPreviewFlag() {
      return this.previewFlag
    },
    viewLayout: {
      get() {
        return this.gridLayout
      },
      set(val) {
        let isEffect = val.filter((v) => !v._id)
        if (!!isEffect.length) return
        this.$emit('update:gridLayout', val)
      },
    },
  },
  watch: {
    gridLayout(newList, oldList) {
      let oldIds = oldList.filter((v) => !!v._id).map((v) => v._id)
      let newRealList = newList.filter((v) => !!v._id)
      const addIndex = newRealList.findIndex((v) => !oldIds.includes(v._id))
      if (addIndex !== -1) {
        this.chartSelect(newRealList[addIndex])
      }
      this.viewLayout = newList
    },
  },
  mounted() {
    // 响应式监测 针对pc和移动端之间切换的兼容
    const el = document.querySelector('.gridlayout')
    elResizeObverse(el, () => {
      const { width } = el.getBoundingClientRect()
      let h = 0
      this.viewLayout.forEach((v) => {
        if (width <= 600) {
          v.ow = v.w ?? v.ow
          v.oy = v.y ?? v.oy
          v.w = 12
          h += v.h
        } else {
          v.w = v.ow ?? v.w
          v.y = v.oy ?? v.y
          delete v.ow
          delete v.oy
        }
      })
      // 强制触发刷新mount让grid重新计算
      if (width <= 600) {
        this.forceUpdateFlag = false
        this.forceUpdateFlag = true
      }
    })
  },
  methods: {
    handleSortChange(column) {
      this.$emit('sort-change', column)
    },
    resizedEvent(item) {
      // 触发 resize 事件，让父组件处理
      this.$emit('grid-resize', item)
    },
    chartSelect(item) {
      this.gridLayout.forEach((v) => {
        v._select = false
      })
      item._select = true
      this.cur = item
      this.$emit('chartSelect', item)
      },
    handleTablePageChange(current, pageSize) {
      this.$emit('table-page-change', current, pageSize)
    },
    handleTableCommand(command, item) {
      this.$emit('handle-table-command', command, item)
    },
    handleDrillItemClick(data, item) {
      this.$emit('drill-item-click', data, item)
    },
  },
}
</script>

<style scoped lang="less">
.bi-layout-drag-handle {
  z-index: 9;
  height: 12px;
  cursor: grab;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  color: rgba(0, 0, 0, .45);
  background: #fff;
  border: 1px solid rgba(0, 0, 0, .12);
  border-radius: 8px;
  align-items: center;
  justify-items: center;
  width: 28px;
  display: grid;
  box-shadow: 0 4px 24px rgba(0, 0, 0, .1);
  top: 0;
  display: none;

  >div {
    height: 2px;
  }
}

.vue-grid-item:hover {
  .bi-layout-drag-handle {
    display: block;
  }
}

.root-container {
  height: 100%;
  width: 100%;
  position: relative;
  scrollbar-gutter: stable;
  user-select: none;
  margin: auto;
  grid-auto-rows: minmax(25px, 25px) !important;
  .gap {
    height: 300px;
  }
  .grid-warp {
    border: 1px solid transparent;
    padding: 8px;

    &:hover {
      box-shadow: 0 6px 10px 0 #d8d7dc;
    }
  }

  .gridlayout {
    height: 100% !important;
  }
}
</style>
